import {Component} from "./Component";
import {FormComponent} from "./FormComponent";
import {AjaxNavigation} from "./AjaxNavigation";
import {Tabs} from "../Tabs";

export class Login extends Component {
    static name = "login";

    get name() {
        return Login.name;
    }

    constructor(el) {
        super(el);

        this.tabs = new Tabs(el);

        this.$loginForm = this.$("loginForm");
        this.$forgotPasswordForm = this.$("forgotPasswordForm");
        this.$restorePasswordForm = this.$("restorePasswordForm");
        this.$acceptInvitationForm = this.$("acceptInvitationForm");

        this.$forgotPasswordButton = this.$("forgotPasswordButton");

        this.$backLink = this.$("backLink");

        this.loginForm = new FormComponent(this.$loginForm, {
            onSubmit: (res) => {
                console.log("LoginForm onSubmit");
                if (res.redirectUrl) {
                    window.location.replace(res.redirectUrl);
                }
            }
        });
        this.forgotPasswordForm = new FormComponent(this.$forgotPasswordForm);

        const FORM_OPTIONS = {
            onSubmit: this.redirectToLoginAfterFormComplete.bind(this),
        };

        if (this.$restorePasswordForm) {
            this.restorePasswordForm = new FormComponent(this.$restorePasswordForm, FORM_OPTIONS);
        }


        if (this.$acceptInvitationForm) {
            this.$acceptInvitationForm = new FormComponent(this.$acceptInvitationForm, FORM_OPTIONS);
        }

        this.addEventListener(this.$forgotPasswordButton, "click", this.onClickForgotPassword.bind(this));

        this.addEventListener(this.$backLink, "click", this.onClickBackLink.bind(this));

        const searchParams = new URLSearchParams(window.location.search);

        if (searchParams.has("action")) {
            this.tabs.show(2);
        }

    }

    onClickForgotPassword(e) {
        e.preventDefault();
        e.stopPropagation();
        this.tabs.show(1);
    }

    onClickBackLink(e) {
        e.preventDefault();
        e.stopPropagation();
        this.tabs.show(0);
    }


    redirectToLoginAfterFormComplete(res) {
        if (!res.error) {
            const redirect = res?.redirectUrl || res?.redirect_url;

            if (redirect) {
                return AjaxNavigation.navigate(redirect);
            }

            this.tabs.show(0);
        }
    }

}
